import { OrganizationApplicationParameters } from '@platform/client/schemas';
import { RadioGroup } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageProps } from '../../Application';
import { useApplicationLocalStorage } from '../../application-hook';
import { ApplicationBackground } from '../../ApplicationBackground';
import { ApplicationPageContent } from '../../components/ApplicationPageContent';
import BackgroundImage from '../../images/Section6.png';

type FormValues = {
  sdgTracking?: string;
};

export const OrgImpactTrackingSelection = (props: ApplicationPageProps) => {
  const { onBack, onContinue, progress, dataKey } = { ...props };

  const { updateApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<OrganizationApplicationParameters>(dataKey);

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      sdgTracking: getApplicationDataByKey('sdgTracking'),
    },
  });

  const onChange = (value?: string | number) => {
    setValue('sdgTracking', value as string);
  };

  const submit: SubmitHandler<FormValues> = (data) => {
    updateApplicationData({
      sdgTracking: data.sdgTracking,
    });
    onContinue();
  };

  const handleBack = () => {
    updateApplicationData({
      sdgTracking: watch('sdgTracking'),
    });
    onBack();
  };

  return (
    <ApplicationBackground
      progress={progress}
      isOrganization={true}
      onBack={handleBack}
      onSubmit={handleSubmit(submit)}
      backgroundImage={BackgroundImage}
      isEditProfile={props.isEditProfile}
    >
      <ApplicationPageContent
        title='Does your organization track and share its social impact or environmental impact?'
        description={'Your answer helps us see if this program is the right fit for you.'}
      >
        <RadioGroup
          name='tracking-status-selection'
          aria-label='tracking-status-selection'
          register={() => {
            return register('sdgTracking', {
              required: 'Select an option to continue',
            });
          }}
          error={errors.sdgTracking?.message}
          items={[
            {
              title: 'Yes, we measure it and share it publicly',
              value: 'yes-public',
            },
            {
              value: 'yes-internal',
              title: 'Yes, we track it but only share it with our team or partners',
            },
            {
              title: "Not yet, but we're working on it",
              value: 'no-in-progress',
            },
            {
              title: "No, we don't currently track or share it",
              value: 'no-not-tracking',
            },
            {
              title: "Not sure or doesn't apply",
              value: 'no-not-applicable',
            },
          ]}
          defaultValue={getApplicationDataByKey('sdgTracking')}
          onChange={onChange}
        />
      </ApplicationPageContent>
    </ApplicationBackground>
  );
};
